//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default{
		data() {
			return {
				url: window.location.href, //当前地址
				// 滚动高度
				diffHeight: 0,
				// 是否显示跳转小程序按钮
				showBtn: false,
				// 品牌id
				brand_id: '',
				// 品牌名称
				brand_name: '',
				// 门店id
				store_id: '',
				// 门店名称
				store_name: '',
				// 是否已使用
				used_status: 0,
			}
		},
		created() {
		    if(sessionStorage.getItem("token") == null) {
		        this.get_token(this.url);
		    }else {
				this.get_conf()
				this.getUrlPam()
			}
		},
		computed: {
			jumpEnv() {
				return location.host.indexOf('dev')>-1 ? 'trial' : 'release'
			},
			originalId() {
				// return location.host.indexOf('dev')>-1 ? 'gh_aece25b74170' : 'gh_0781b44c59e1'
				// 临时写死原始id
				return location.host.indexOf('dev')>-1 ? 'gh_aece25b74170' : 'gh_b298b8d2c266'
			},
			isIos() {
				var agent = navigator.userAgent.toLowerCase()
				return (/(iphone|iPad|iOS)/i).test(agent)
			},
			historyLength() {
				return window.history.length
			}
		},
		methods: {
			//获取token
			get_token(url) {
			    this.$EpetJs.Common.approve(url,()=> {
					this.get_conf()
					this.getUrlPam()
				}); //生成token
			},
			get_conf() {
			    //微信js授权config
			    this.$EpetJs.Common.get_conf(this.url, (res)=> {
					res.openTagList = res.openTagList || []
					res.openTagList.push('wx-open-launch-weapp')
			        this.$wx.config(res)
			    });
			},
			// 获取链接参数
			getUrlPam() {
				this.brand_name = this.$EpetJs.Helper.getUrlParam("brand_name")
				this.store_name = this.$EpetJs.Helper.getUrlParam("store_name")
				this.store_id = this.$EpetJs.Helper.getUrlParam("store_id")
				this.brand_id = this.$EpetJs.Helper.getUrlParam("brand_id")
				this.used_status = this.$EpetJs.Helper.getUrlParam("used_status")
			},
			// 图片加载完毕，计算高度差
			loadImg() {
				let scrollHeight = document.body.scrollHeight
				let imgHeight = this.$refs.inviteImg.clientHeight
				const diffHeight = imgHeight > scrollHeight ? imgHeight - scrollHeight : 0
				this.diffHeight = diffHeight
				setTimeout(()=>{
					this.showBtn = true
				},7000)
			}
		}
	}
